import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/rolePageHeader.css';

const MetierPageHeader = ({ setOpenAddMetier, hasMetierCreatePermission }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const handleAddMetier = useCallback(() => {
        setOpenAddMetier(true);
    }, [setOpenAddMetier]);

    return (
        <Box className='role_page_header_main_container'>
            <Box className='role_page_header_title_box'>
                <Typography className='role_page_header_page_title'>{t("Métiers")}</Typography>
            </Box>
            {isDesktop && hasMetierCreatePermission &&
                <Box className='role_page_header_action_box' onClick={handleAddMetier}>
                    <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='role_page_header_action_title'>{t("addMetierDialogeTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='role_page_header_action_box'>
                    {hasMetierCreatePermission && <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddMetier} />}
                </Box>
            }
        </Box>
    );
};

export default React.memo(MetierPageHeader);